<template>
    <v-container>
        Settings
    </v-container>
</template>

<script>
    export default {
        name: "SettingView"
    }
</script>

<style scoped>

</style>
